import { PriceObjectDto } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { LightInvoiceDto } from "@modules/finances/gateway/lightInvoiceDto"

export class LightInvoiceEntity {
  price: PriceObjectDto
  invoiceDate: Date

  private constructor(lightInvoice: { price: PriceObjectDto; invoiceDate: Date }) {
    this.price = lightInvoice.price
    this.invoiceDate = new Date(lightInvoice.invoiceDate)
  }

  static fromDto(dto: LightInvoiceDto): LightInvoiceEntity {
    return new LightInvoiceEntity({
      price: dto.price,
      invoiceDate: new Date(dto.invoiceDate),
    })
  }

  static toDto(entity: LightInvoiceEntity): LightInvoiceDto {
    return {
      price: entity.price,
      invoiceDate: entity.invoiceDate.toISOString(),
    }
  }
}
